import { createContext, useContext, useState } from "react";

const ExecutionContext = createContext();

export const ExecutionProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    status: "", // ← string, no array
    node: "",
    lastUpdate: "",
    search: "",
  });

  const updateFilters = (updates) => {
    console.log("Updating Filters with:", updates);
    setFilters((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const clearFilters = () => {
    setFilters({
      status: "",
      node: "",
      lastUpdate: "",
      search: "",
    });
  };

  return (
    <ExecutionContext.Provider value={{ filters, updateFilters, clearFilters }}>
      {children}
    </ExecutionContext.Provider>
  );
};

export const useExecution = () => useContext(ExecutionContext);
